import React from "react";
import {
  FaLinkedin,
  FaInstagram,
  FaTwitter,
  FaGoogle,
  FaYoutube,
  FaFacebookF,
  FaPhoneAlt,
} from "react-icons/fa";
import headerLogo from "../../assets/cropped-logo.webp";
import { Footer_MENU_LIST } from "../../constant/FooterData";
import { COMPANY_DATA } from "../../constant/CompanyData";
import { Link } from "react-router-dom";
import { openConsentPreferences } from "../../utils/cookieConsent";
import Eyebrow from "../common/Eyebrow";
import CertSeal from "../DataCenters/CertSeal";
import { CERTIFICATES_DATA } from "../../constant/CompanyData";

const isoCode = (title) => title.match(/\d{4,5}/)?.[0] ?? "";
const Footer = () => {
  return (
    <>
      <section className="border-y border-slate-200 bg-slate-50 px-6 py-7">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-5 md:flex-row">
          <div className="text-center md:text-left">
            <Eyebrow className="tracking-[0.18em]">Your feedback matters</Eyebrow>
            <h3 className="mt-1 text-xl font-bold text-[var(--website-primary-color)]">
              Help businesses choose infrastructure with confidence.
            </h3>
            <p className="mt-1 text-sm text-slate-600">
              Share your QuantaRock experience on Trustpilot.
            </p>
          </div>
          <a
            href="https://www.trustpilot.com/evaluate/quantarock.in"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex rounded-full bg-[var(--website-primary-color)] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[var(--primary-hover)]"
          >
            Review us on Trustpilot
          </a>
        </div>
      </section>

      <footer className="bg-gradient-to-b from-[var(--surface-dark)] to-[var(--surface-sunken)] px-6 py-14 text-white">
        <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1.25fr_2.75fr]">
          <div className="flex min-w-0 flex-col items-center text-center md:items-start md:text-left">
            <Link to="/">
              <img
                src={headerLogo}
                alt={`${COMPANY_DATA.companyName} Logo`}
                className="h-auto w-48 cursor-pointer"
                loading="lazy"
                width={763}
                height={157}
              />
            </Link>
            <p className="mt-5 max-w-sm break-words text-sm leading-relaxed text-slate-300">
              Enterprise infrastructure, cloud, and managed IT services built
              for dependable operations and sustainable growth.
            </p>
            <div className="mt-6 max-w-sm space-y-2 break-words text-sm leading-relaxed text-slate-300">
              <a className="block transition hover:text-[var(--website-secondary-color)]" href={`mailto:${COMPANY_DATA.mailID}`}>
                {COMPANY_DATA.mailID}
              </a>
              <a className="block transition hover:text-[var(--website-secondary-color)]" href={`tel:${COMPANY_DATA.phoneNumber}`}>
                {COMPANY_DATA.phoneNumber}
              </a>
              <p>{COMPANY_DATA.address}</p>
            </div>
            <div className="mt-6 flex flex-wrap justify-center gap-2 md:justify-start">
              <a
                href={`tel:${COMPANY_DATA.phoneNumber}`}
                aria-label="Call QuantaRock"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaPhoneAlt size={18} />
              </a>
              <a
                href={COMPANY_DATA.linkedInURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QuantaRock on LinkedIn"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaLinkedin size={18} />
              </a>
              <a
                href={COMPANY_DATA.facebookURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QuantaRock on Facebook"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href={COMPANY_DATA.mailURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Email QuantaRock"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaGoogle size={18} />
              </a>
              <a
                href={COMPANY_DATA.twitterURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QuantaRock on X"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaTwitter size={18} />
              </a>
              <a
                href={COMPANY_DATA.instaURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QuantaRock on Instagram"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href={COMPANY_DATA.youtubeURL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="QuantaRock on YouTube"
                className="rounded-full border border-white/15 p-2.5 text-white transition hover:border-[var(--website-secondary-color)] hover:bg-[var(--website-secondary-color)] hover:text-[var(--on-secondary)]"
              >
                <FaYoutube size={18} />
              </a>
            </div>

            <div className="mt-7">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-full bg-[var(--website-secondary-color)] px-5 py-3 text-sm font-semibold text-[var(--on-secondary)] transition hover:opacity-95"
              >
                Request a quote
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-4">
            {Footer_MENU_LIST.map((section) => (
              <div key={section.title}>
                <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.16em] text-white">
                  {section.title}
                </h4>
                {section.links.map((link, linkIndex) => (
                  <Link
                    key={linkIndex}
                    to={link.pageId}
                    className="mb-3 block text-left text-sm leading-snug text-slate-300 transition-colors hover:text-[var(--website-secondary-color)]"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            ))}
          </div>
               </div>

        {/* Certifications */}
        <div className="mx-auto mt-12 max-w-6xl border-t border-white/10 pt-10">
          <div className="text-center">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-white">
              Certifications & Compliance
            </h3>

            <p className="mt-2 text-sm text-slate-400">
              Certified standards that support our commitment to quality,
              security, and reliable infrastructure.
            </p>
          </div>

          <div className="mt-7 flex flex-wrap items-center justify-center gap-6">
            {CERTIFICATES_DATA.map((cert) => (
              <a
                key={cert.id}
                href={cert.file}
                target="_blank"
                rel="noopener noreferrer"
                title={cert.title}
                className="group flex flex-col items-center gap-2 px-3"
              >
                <CertSeal
                  code={isoCode(cert.title)}
                  size={90}
                />

                <span className="text-center text-xs font-semibold text-slate-300 transition group-hover:text-[var(--website-secondary-color)]">
                  {cert.title}
                </span>
              </a>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-12 flex max-w-6xl flex-col gap-3 border-t border-white/10 pt-6 text-sm text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {COMPANY_DATA.companyName}. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={openConsentPreferences}
              className="underline decoration-white/20 underline-offset-2 transition hover:text-white hover:decoration-white/50"
            >
              Cookie Preferences
            </button>
            <p>Secure infrastructure. Expert support. Built for growth.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
